import React from 'react';
import { TrustCenterPage } from './pages/TrustCenterPage';
export function App() {
  return <TrustCenterPage data-id="element-0" />;
}